import { oc } from '@orpc/contract';
import { previewTemplateVersionInputSchema, previewTemplateVersionOutputSchema } from '../schemas/templates.schemas.js';
/** Prices the built-in reference sample with this version's values through the published policy. */
export const previewTemplateVersionContract = oc
    .route({
    method: 'GET',
    path: '/templates/versions/{versionId}/preview',
    tags: ['Templates'],
    summary: 'Preview a template version on the reference sample',
})
    .input(previewTemplateVersionInputSchema)
    .output(previewTemplateVersionOutputSchema);
//# sourceMappingURL=preview-template-version.contract.js.map